<header-mobile-component  [color]="color" [title]="title" *ngIf="template == 'mobile'"></header-mobile-component>
<header-desktop-component [profilePicture]="profilePicture" [username]="username" *ngIf="template == 'desktop'"></header-desktop-component>

